import React from "react";

import DemoReel2020 from "../../../resources/videos/DemoReel2020.mp4";

import Button from "../../common/Button";

const HeroTextWithHighlight = ({
  heroContent,
  homepageHeroHighlightedText,
}) => {
  const heroWithoutHighlightText = heroContent.replace(
    homepageHeroHighlightedText,
    "!@#$%"
  );
  const list = heroWithoutHighlightText.split("!@#$%");
  return (
    <>
      <font className="homepage-banner-header-text">
        {list[0]}
        <span className="homepage-banner-header-highlighted">
          {homepageHeroHighlightedText}
        </span>
        {list[1]}
      </font>
    </>
  );
};

export default (
  heroContent,
  homepageHeroHighlightedText,
  homepageHeroSubtitleText
) => (
  <div className="homepage-banner">
    <div className="homepage-banner-header-container">
      <div>
        <h1
          className="homepage-banner-header"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <HeroTextWithHighlight
            heroContent={heroContent}
            homepageHeroHighlightedText={homepageHeroHighlightedText}
          />
          <font className="homepage-banner-header__subheader">
            {homepageHeroSubtitleText}.
          </font>
        </h1>
      </div>
      <div className="homepage-banner-links">
        <Button
          text="Book a Consultation"
          isNewWindow
          href="https://wakefield.agency/contact-us"
        />
        {/* <BannerLinks mr={["12px", "12px", "12px", "12px", "26px"]}>
          <Link to="/portfolio">
            <span>Our Work</span>
          </Link>
        </BannerLinks>
        <BannerLinks>
          <Link to="/about#about-us-process">
            <span>Our Process</span>
          </Link>
        </BannerLinks> */}
      </div>
    </div>
    <video
      className="homepage-banner-video"
      playsInline
      autoPlay
      loop
      muted={true}
    >
      <source src={DemoReel2020} type="video/mp4" />
    </video>
  </div>
);
